import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { saveLastQuery } from 'common/pager/ducks';
import { getValueFromQuery, getPageCountFromState } from 'common/pager/utils'
import Pager from 'common/pager/components';

export const mapStateToProps = (state, { resourceName, location }) => {
  return {
    value: getValueFromQuery(resourceName, location.query),
    pageCount: getPageCountFromState(resourceName, state)
  };
}

export default withRouter(connect(mapStateToProps, { saveLastQuery })(Pager));



// WEBPACK FOOTER //
// ./common/pager/containers/index.js